// AssistantThreadUnavailable — the thread view's "not available" line. The
// address bar names a conversation this person cannot read (private, deleted,
// another workspace's — the server answers the same 404 for each), so the
// view shows NO rows and says so. It stands in the empty thread's reading
// column, above the hint that points at the composer: the next question
// starts a new conversation, and takes this line away with the hint.
//
// Mounted by bare key in components/AssistantMainThread.js. Kept mounted and
// only hidden (Rule 66); an alert, so the state is announced when it shows.
// functions/assistantThreadUrl.js `assistantThreadUnavailable` holds the rule.
export const AssistantThreadUnavailable = {
  tag: 'p',
  role: 'alert',
  dataThreadUnavailable: true,
  hide: (el, s) => !el.call('assistantThreadUnavailable', s && s.root),
  margin: '0',
  maxWidth: 'I',
  marginInline: 'auto',
  fontSize: 'A',
  color: 'title',
  textAlign: 'center',
  text: '{{ workspace.simone.threadUnavailable | polyglot }}'
}
